let kissmetricsLoaded = false;

function loadScript(src) {
    return new Promise((resolve, reject) => {
        // Prevent loading the same script twice
        if (document.querySelector(`script[src="${src}"]`)) {
            return resolve();
        }

        const script = document.createElement("script");
        script.src = src;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;

        document.head.appendChild(script);
    });
}

async function kissmetrics(user) {
    const KEY = import.meta.env.VITE_KISSMETRICS_KEY;
    if (!KEY || !user) return;
    // Ensure global queue + key exist
    window._kmq = window._kmq || [];
    window._kmk = window._kmk || KEY;

    // Load only once
    if (!kissmetricsLoaded) {
        kissmetricsLoaded = true;

        await Promise.all([
            loadScript("//i.kissmetrics.io/i.js"),
            loadScript(`//scripts.kissmetrics.io/${window._kmk}.2.js`)
        ]);
    }

    // Identify the user after scripts are ready
    window._kmq.push(["identify", user.email]);
    window._kmq.push(["set", { Name: user.name }]);
}

export default kissmetrics;
